module.exports = __webpack_public_path__ + "static/stefan-6e99f881843ef09f8dda293561b979e9.png";